if (!customElements.get('bundel-korting')) {
  customElements.define('bundel-korting', class BundelKorting extends HTMLElement {
    connectedCallback() {
      this.product = JSON.parse(this.querySelector('[data-bk-product]').textContent);
      const ontcijfer = document.createElement('textarea');
      ontcijfer.innerHTML = JSON.parse(this.querySelector('[data-bk-geld]').textContent) || '€{{amount_with_comma_separator}}';
      this.geldFormaat = ontcijfer.value;
      this.pack = parseInt(this.dataset.pack, 10) || 1;
      this.perStuk = this.dataset.perStuk === 'true';
      this.form = document.getElementById(this.dataset.form);
      this.fout = this.querySelector('.bundelkorting__fout');
      this.staffels = [...this.querySelectorAll('.bundelkorting__staffel')];
      if (!this.form || !this.staffels.length) return;

      this.idVeld = this.form.querySelector('input[name="id"]');
      this.variant = this.vindVariant(parseInt(this.idVeld && this.idVeld.value, 10)) || this.product.variants.find((v) => v.available) || this.product.variants[0];
      this.regels = [];

      if (this.dataset.verbergAantal === 'true') {
        const aantal = document.getElementById(`quantity-${this.dataset.section}`);
        if (aantal) aantal.hidden = true;
      }

      if (!this.querySelector('input[type="radio"]:checked')) {
        this.staffels[0].querySelector('input').checked = true;
      }
      this.staffels.forEach((s) => {
        s.querySelector('input').addEventListener('change', () => this.kies());
      });

      if (this.idVeld && !this.idVeld._bundelkorting) {
        this.idVeld._bundelkorting = true;
        this.idVeld.addEventListener('change', () => {
          const v = this.vindVariant(parseInt(this.idVeld.value, 10));
          if (!v) return;
          this.variant = v;
          this.regels = [];
          this.kies();
        });
      }

      if (!this.form._bundelkorting) {
        this.form._bundelkorting = true;
        this.form.addEventListener('submit', (e) => this.verstuur(e), true);
      }
      this.kies();
    }

    vindVariant(id) {
      return this.product.variants.find((v) => v.id === id);
    }

    gekozenAantal() {
      const r = this.querySelector('input[type="radio"]:checked');
      return r ? parseInt(r.value, 10) : 1;
    }

    geld(centen) {
      const bedrag = (Math.max(0, centen) / 100);
      const metKomma = bedrag.toFixed(2).replace('.', ',');
      const zonder = bedrag.toFixed(2);
      return this.geldFormaat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, metKomma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(bedrag).toString())
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(bedrag).toString())
        .replace(/\{\{\s*amount\s*\}\}/, zonder)
        .replace(/<[^>]*>/g, '');
    }

    zorgVoorRegels(aantal) {
      while (this.regels.length < aantal) this.regels.push(this.variant.id);
      this.regels.length = aantal;
    }

    kies() {
      const aantal = this.gekozenAantal();
      this.zorgVoorRegels(aantal);
      this.staffels.forEach((s) => {
        const gekozen = parseInt(s.dataset.aantal, 10) === aantal && s.querySelector('input').checked;
        s.classList.toggle('is-gekozen', gekozen);
        const vak = s.querySelector('[data-regels]');
        vak.innerHTML = '';
        if (gekozen && this.perStuk && aantal > 1 && this.product.variants.length > 1) {
          vak.appendChild(this.maakRegels(aantal));
        }
      });
      this.prijzen();
      this.toonFout('');
    }

    maakRegels(aantal) {
      const lijst = document.createElement('span');
      lijst.className = 'bundelkorting__lijst';
      for (let i = 0; i < aantal; i++) {
        const rij = document.createElement('span');
        rij.className = 'bundelkorting__regel';
        const nr = document.createElement('span');
        nr.className = 'bundelkorting__nr';
        nr.textContent = `#${i + 1}`;
        rij.appendChild(nr);
        this.product.options.forEach((optie, o) => {
          const kiezer = document.createElement('select');
          kiezer.className = 'bundelkorting__select';
          kiezer.setAttribute('aria-label', `${optie} voor stuk ${i + 1}`);
          kiezer.dataset.optie = o;
          rij.appendChild(kiezer);
          kiezer.addEventListener('click', (e) => e.stopPropagation());
          kiezer.addEventListener('change', () => this.wijzigRegel(i, rij));
        });
        lijst.appendChild(rij);
        this.vulRegel(i, rij);
      }
      return lijst;
    }

    vulRegel(i, rij) {
      const variant = this.vindVariant(this.regels[i]) || this.variant;
      rij.querySelectorAll('select').forEach((kiezer) => {
        const o = parseInt(kiezer.dataset.optie, 10);
        const waarden = [...new Set(this.product.variants.map((v) => v.options[o]))];
        kiezer.innerHTML = '';
        waarden.forEach((w) => {
          const keuze = variant.options.slice();
          keuze[o] = w;
          const past = this.product.variants.find((v) => v.options.every((x, n) => x === keuze[n]));
          const el = document.createElement('option');
          el.value = w;
          el.textContent = past && past.available ? w : `${w} (uitverkocht)`;
          el.disabled = !past || !past.available;
          el.selected = w === variant.options[o];
          kiezer.appendChild(el);
        });
      });
      rij.classList.toggle('is-uitverkocht', !variant.available);
    }

    wijzigRegel(i, rij) {
      const keuze = [...rij.querySelectorAll('select')].map((k) => k.value);
      const v = this.product.variants.find((x) => x.options.every((w, n) => w === keuze[n]));
      if (v) this.regels[i] = v.id;
      this.vulRegel(i, rij);
      this.prijzen();
      this.toonFout('');
    }

    prijzen() {
      const gekozen = this.gekozenAantal();
      this.staffels.forEach((s) => {
        const aantal = parseInt(s.dataset.aantal, 10);
        const korting = parseFloat(s.dataset.korting) || 0;
        const prijzen = aantal === gekozen
          ? this.regels.map((id) => (this.vindVariant(id) || this.variant).price)
          : Array(aantal).fill(this.variant.price);
        const totaal = prijzen.reduce((som, p) => som + p, 0);
        const eraf = prijzen.reduce((som, p) => som + Math.floor(p * korting / 100), 0);
        const nu = s.querySelector('[data-nu]');
        const was = s.querySelector('[data-was]');
        const chip = s.querySelector('[data-chip]');
        if (nu) nu.textContent = this.geld(totaal - eraf);
        if (was) was.textContent = this.geld(totaal);
        if (chip) chip.textContent = `Korting ${this.geld(eraf)}`;
      });
    }

    toonFout(tekst) {
      this.fout.textContent = tekst;
      this.fout.hidden = !tekst;
    }

    toonDeelsToegevoegd(root, secties, voor, ids, productForm) {
      if (!productForm || !productForm.renderContents) return;
      return Promise.all([
        fetch(`${root}cart.js`).then((r) => r.json()),
        secties.length ? fetch(`${window.location.pathname}?sections=${secties.join(',')}`).then((r) => r.json()) : {}
      ]).then(([wagen, html]) => {
        const erbij = voor === null
          ? wagen.items.some((i) => ids.includes(i.variant_id))
          : wagen.item_count > voor;
        if (!erbij) return;
        productForm.renderContents({ sections: html, items: wagen.items });
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', { product: wagen.items.find((i) => ids.includes(i.variant_id)) });
        }
      }).catch(() => {});
    }

    verstuur(e) {
      const aantal = this.gekozenAantal();
      if (aantal <= 1 && this.dataset.verbergAantal !== 'true') return;
      e.preventDefault();
      e.stopImmediatePropagation();

      const items = new Map();
      const ids = aantal > 1 && this.perStuk ? this.regels.slice(0, aantal) : Array(aantal).fill(this.variant.id);
      for (const id of ids) {
        const v = this.vindVariant(id);
        if (!v || !v.available) {
          this.toonFout('Een van de gekozen kleuren of maten is uitverkocht. Kies een andere.');
          return;
        }
        items.set(id, (items.get(id) || 0) + 1);
      }

      const knoppen = document.querySelectorAll('.single-add-to-cart-button');
      knoppen.forEach((k) => { k.classList.add('loading'); k.setAttribute('aria-disabled', true); });
      this.toonFout('');
      const productForm = this.form.closest('product-form');
      const secties = productForm && productForm.getSectionsToRender
        ? productForm.getSectionsToRender().map((s) => s.section) : [];
      const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      const teller = document.querySelector('#cart-drawer-toggle .thb-item-count');
      const voor = teller ? parseInt(teller.textContent, 10) || 0 : null;

      fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [...items].map(([id, quantity]) => ({ id, quantity })),
          sections: secties.join(','),
          sections_url: window.location.pathname
        })
      })
        .then((r) => r.json())
        .then((antwoord) => {
          if (antwoord.status) {
            this.toonFout(antwoord.description || antwoord.message || 'Toevoegen lukte niet.');
            return this.toonDeelsToegevoegd(root, secties, voor, [...items.keys()], productForm);
          }
          if (productForm && productForm.renderContents) productForm.renderContents(antwoord);
          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart:item-added', { product: (antwoord.items || [])[0] });
          }
        })
        .catch(() => this.toonFout('Toevoegen lukte niet. Probeer het nog eens.'))
        .finally(() => {
          knoppen.forEach((k) => { k.classList.remove('loading'); k.removeAttribute('aria-disabled'); });
        });
    }
  });
}
